var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Verificación Baja Por Cliente")])], 1),
      _c("v-divider"),
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs2: "", sm2: "", md2: "" } },
                [
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateStart.label,
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateStart.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateStart, "value", $$v)
                      },
                      expression: "formFields.dateStart.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs2: "", sm2: "", md2: "" } },
                [
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateEnd.label,
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateEnd.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                      },
                      expression: "formFields.dateEnd.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs2: "", sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.estado.label,
                      items: _vm.estados,
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.estado.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.estado, "value", $$v)
                      },
                      expression: "formFields.estado.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs2: "", sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.cliente.label,
                      items: _vm.clientes,
                      "item-text": "nombre",
                      "item-value": "id",
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.cliente.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cliente, "value", $$v)
                      },
                      expression: "formFields.cliente.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs2: "", sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.motivo.label,
                      items: _vm.motivos,
                      "item-text": "motiname",
                      "item-value": "motiid",
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.motivo.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.motivo, "value", $$v)
                      },
                      expression: "formFields.motivo.value"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                _c(
                  "div",
                  { staticClass: "text-sm-center botones-filtros mt-1" },
                  [
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            return _vm.filtrar()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "#27488e" } }, [
                          _vm._v("search")
                        ]),
                        _vm._v("Filtrar\n          ")
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            return _vm.clearFilters()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "#27488e" } }, [
                          _vm._v("clear")
                        ]),
                        _vm._v("Limpiar")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Buscar", clearable: "", outlined: "" },
                on: {
                  keyup: function($event) {
                    return _vm.gridApi.setQuickFilter(_vm.filtro)
                  },
                  "click:clear": function($event) {
                    return _vm.gridApi.setQuickFilter("")
                  }
                },
                model: {
                  value: _vm.filtro,
                  callback: function($$v) {
                    _vm.filtro = $$v
                  },
                  expression: "filtro"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card VerificacionBajaCliente" },
        [
          _c("MantenedorGrid", {
            staticClass: "ag-theme-material",
            attrs: { gridOptions: _vm.gridOptions }
          })
        ],
        1
      ),
      _vm.showModalEdit
        ? _c("EditarSolicitud", {
            attrs: { editedItem: _vm.editedItem },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }